import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/card-bg.png'
import _imports_1 from '@/assets/icon/card1.png'


const _withScopeId = n => (_pushScopeId("data-v-a931492a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-con" }
const _hoisted_2 = { class: "card-con" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_4 = { class: "card-info" }
const _hoisted_5 = { class: "cls-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"height":"1rem","width":"auto"}
}, null, -1))
const _hoisted_7 = { style: {"padding":"0 0 0.1rem 0.3rem"} }
const _hoisted_8 = { style: {"font-size":"1.5rem"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-time" }, "有效期：永久", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"padding-top":"0.5rem"}
}, "权益说明", -1))
const _hoisted_11 = { style: {"padding-top":"0.8rem"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"padding-top":"0.5rem"}
}, "使用规则", -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  class: "cls-flex",
  style: {"padding":"0.8rem"}
}
const _hoisted_15 = { class: "pay-price" }
const _hoisted_16 = { style: {"flex":"1"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#764820"} }, "立即开通", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.card.cardName), 1)
          ]),
          _createElementVNode("div", _hoisted_8, "￥" + _toDisplayString(_ctx.card.cardPrice), 1),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _createElementVNode("div", null, _toDisplayString(_ctx.card.attentionNotes), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          innerHTML: _ctx.card.explainNotes
        }, null, 8, _hoisted_13)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showBuy,
      position: "bottom",
      overlay: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, "￥" + _toDisplayString(_ctx.card.cardPrice), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_van_button, {
              onClick: _ctx.pay_click,
              block: "",
              round: "",
              color: "linear-gradient(180deg, #F2DBB5 0%, #ECC489 100%)"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}